export default () => ({
  page: null,
  rememberEmail: false,
  errorState: [],
  formPosted: false,
  showPreferenceText: false,
  showLoginText: false,

  init() {
    this.page = window.location.pathname;
    const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
    const rememberedEmailCookie = cookies.find((cookie) =>
      cookie.startsWith("rememberedEmail=")
    );
    if (rememberedEmailCookie) {
      const rememberedEmail = decodeURIComponent(
        rememberedEmailCookie.split("=")[1]
      );
      document.addEventListener("DOMContentLoaded", () => {
        document.getElementById("CustomerEmail").value = rememberedEmail;
      });
      this.rememberEmail = true;
    }
    CF.customerReady(
      function () {
        // Todo: rewrite this to be more dynamic
        const tops = CF.customer.get("preference_size_tops");
        const bottoms = CF.customer.get("preference_size_bottoms");
        const shoes = CF.customer.get("preference_size_shoes");
        const tailoring = CF.customer.get("preference_size_tailoring");

        const gender = CF.customer.get("preference_gender");
        const interests = CF.customer.get("preference_interests");

        if (
          tops &&
          tops.length > 0 &&
          bottoms &&
          bottoms.length > 0 &&
          shoes &&
          shoes.length > 0 &&
          tailoring &&
          tailoring.length > 0 &&
          gender &&
          interests &&
          interests.length > 0
        ) {
          this.showLoginText = true;
        } else {
          this.showPreferenceText = true;
        }
      }.bind(this)
    );
  },
  toggleRememberEmail() {
    this.rememberEmail = !this.rememberEmail;
  },
  checkErrorState(errorState) {
    if ([...this.errorState].includes(errorState)) {
      return true;
    }
    return false;
  },
  submitForm(currentUrl) {
    const form = document.getElementById("customer_login");
    const emailInput = document.getElementById("CustomerEmail");
    this.errorState = [];

    if (this.rememberEmail) {
      document.cookie = `rememberedEmail=${encodeURIComponent(
        emailInput.value
      )}; expires=${new Date(
        Date.now() + 30 * 24 * 60 * 60 * 1000
      ).toUTCString()}; path=/`;
    } else {
      document.cookie =
        "rememberedEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailInput.value)) {
      this.errorState.push("email_invalid");
      return;
    }

    const formData = new FormData(form);

    fetch("/account/login", {
      method: "POST",
      body: formData,
    }).then((response) => {
      const isValidLogin = !response.url.includes("login");

      if (isValidLogin) {
        //this.formPosted = true;

        Shopify.analytics.publish("login", {
          method: "email",
          email: emailInput.value,
        });

        window.location.href = window.routes.login_return_url;
      } else {
        this.errorState.push("login_failed");
      }
    });
  },
});
